const TOKEN_KEY = 'utoken';
const TOKEN_EXPIRY_KEY = 'utoken_exp';
const TOKEN_PREFIX = 'Bearer ';

/**
 * Token 管理器
 *
 * - 内存优先存储，减少持久化存储读取开销
 * - localStorage 持久化，关闭浏览器后 token 仍有效
 * - 支持 token 过期自动清理
 */
class TokenManager {
  private memoryToken: string | null = null;
  private expiryTime: number | null = null;

  setToken(rawToken: string, expireAtSeconds?: number) {
    const token = TOKEN_PREFIX + rawToken;
    this.memoryToken = token;

    if (expireAtSeconds && expireAtSeconds > 0) {
      this.expiryTime = expireAtSeconds * 1000;
      try {
        window.localStorage.setItem(TOKEN_EXPIRY_KEY, String(this.expiryTime));
      } catch {
        // localStorage 不可用时静默降级
      }
    }

    try {
      window.localStorage.setItem(TOKEN_KEY, token);
    } catch {
      // localStorage 不可用时依赖内存
    }
  }

  getToken(): string | null {
    const stored = this.getStoredToken();
    if (stored && stored.token !== this.memoryToken) {
      this.memoryToken = stored.token;
      this.expiryTime = stored.expiryTime;
    }

    if (this.isExpired()) {
      this.removeToken(this.memoryToken);
      return null;
    }

    if (this.memoryToken) {
      return this.memoryToken;
    }

    return null;
  }

  removeToken(expectedToken?: string | null) {
    this.memoryToken = null;
    this.expiryTime = null;
    try {
      const stored = window.localStorage.getItem(TOKEN_KEY);
      if (expectedToken && stored && stored !== expectedToken) {
        return;
      }
      window.localStorage.removeItem(TOKEN_KEY);
      window.localStorage.removeItem(TOKEN_EXPIRY_KEY);
    } catch {
      // ignore
    }
  }

  isExpired(): boolean {
    if (!this.expiryTime && !this.memoryToken) {
      return false;
    }
    if (!this.expiryTime) {
      const expStr = window.localStorage.getItem(TOKEN_EXPIRY_KEY);
      if (expStr) {
        this.expiryTime = Number(expStr);
      }
    }
    if (this.expiryTime && Date.now() > this.expiryTime) {
      return true;
    }
    return false;
  }

  private getStoredToken(): { token: string; expiryTime: number | null } | null {
    try {
      const token = window.localStorage.getItem(TOKEN_KEY);
      if (!token) {
        return null;
      }
      const expStr = window.localStorage.getItem(TOKEN_EXPIRY_KEY);
      return {
        token,
        expiryTime: expStr ? Number(expStr) : null,
      };
    } catch {
      // localStorage 不可用
      return null;
    }
  }
}

export const tokenManager = new TokenManager();
